import React from "react";
import { Box } from "@mui/material";
import Layout4 from "../../Pages/DataLayouts/Layout4";

export default function WalletPageShell({ heading, subtitle, children }) {
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1200 }}>
      <Layout4 heading={heading} subtitle={subtitle} showAddButton={false} />
      {children}
    </Box>
  );
}
